import { SocialButtonProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: SocialButtonProps = {};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as SocialButtonProps,
  },
];

export const testkitTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
      icon: 'facebook',
      text: 'Share me please!',
    } as SocialButtonProps,
  },
];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
